import archidekt from '@/assets/svgs/archidekt.svg'
import { ButtonDefault } from '@/components/common/Button'
import { CardRec } from '@/components/common/Card'
import { CardCatalog } from '@/components/common/CardCatalog'
import { DecklistBuyLinks } from '@/components/common/DecklistBuyLinks'
import { IconImage } from '@/components/icons/IconImage'
import { parseArchidektDeck } from '@/utils/brandUtil'
import { parseGalleryDeck, parseGalleryDeckText } from '@/utils/galleryUtil'
import { buildRec } from '@/utils/recUtil'

import styles from './DeckEmbed.module.scss'

type Props = {
  archidektLink?: string
  rawDeck?: string
  title?: string
}

export const DeckEmbed = ({ archidektLink, rawDeck, title }: Props) => {
  const groups = parseGalleryDeck(rawDeck)
  const recs = groups.flatMap(({ recs }) => recs)

  const decklistText = parseGalleryDeckText(recs)
  const archidektDeck = parseArchidektDeck(groups)

  const commanderRecs = groups.find((g) => g.slug === 'commander')?.recs.slice(0, 2) || []

  const { cardId, name } = commanderRecs[0] || {}
  const partner = commanderRecs[1]
  const commanderRec =
    name && cardId
      ? buildRec({ cardId, name, partnerRef: partner && { cardId: partner.cardId, name: partner.name } })
      : undefined

  return (
    <div className={styles.container}>
      <div
        dangerouslySetInnerHTML={{
          __html: `<!-- ${JSON.stringify(archidektDeck)} -->`,
        }}
        id='deck_for_archidekt_scraper'
      />
      <h3 className={styles.heading}>{title || 'Decklist'}</h3>
      <div className={styles.main}>
        <div className={styles.mainFeatured}>
          <div className={styles.mainFeaturedInner}>
            {commanderRec && <CardRec disableLink extend rec={commanderRec} />}
            <div className={styles.buttonWrap}>
              {archidektLink && (
                <ButtonDefault
                  as='LinkOutbound'
                  colorScheme='archidekt'
                  href={archidektLink}
                  utm={{ medium: 'article' }}
                >
                  <div className={styles.archidektButton}>
                    <IconImage className={styles.archidektIcon} src={archidekt.src} />
                    <span>View on Archidekt</span>
                  </div>
                </ButtonDefault>
              )}
              <DecklistBuyLinks decklist={decklistText} />
            </div>
          </div>
        </div>
        <div className={styles.mainCatalog}>
          <CardCatalog groups={groups} variant='embed' />
        </div>
      </div>
    </div>
  )
}
